<template>
  <div :style="{ '--color': color, '--borderColor': borderColor }">
    <ValidationProvider
      v-if="validation"
      :rules="validation"
      v-slot="{ errors }"
      :name="name || label"
    >
      <div
        class="textInputWrapper form-group"
        :style="`${customWrapperStyle}; font-family: ${fontFamily}`"
      >
        <textarea
          :style="styles"
          class="form-control textInput"
          :class="{ 'is-invalid': errors.length }"
          :value="text == '' ? value : text"
          @input="updateValue($event.target.value)"
          ref="input"
          :name="label"
          :id="name"
          :maxlength="maxlength"
          :minlength="minlength"
          @paste="pasteHandler"
        ></textarea>
        <!-- <img
          v-if="errors.length"
          class="error_min inputError"
          src="../../assets/icons/risk-icon.svg"
          height="18px"
          width="18px"
          alt
        /> -->
        <span class="floating-label" :class="{ slideUp: slideUp }">{{
          label
        }}</span>
      </div>
      <div class="validation-error" v-if="errors.length">{{ errors[0] }}</div>
    </ValidationProvider>
    <div class="m-0 p-0" v-else>
      <div class="textInputWrapper form-group">
        <input
          :autocomplete="autocomplete"
          type="text"
          :style="`${styles}; font-family: ${fontFamily}`"
          class="form-control textInput"
          :value="value"
          @input="updateValue($event.target.value)"
          ref="input"
          :name="name"
          :id="name"
        />
        <span class="floating-label" :class="{ slideUp: slideUp }">{{
          label
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "text-area",
  props: {
    name: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: String
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    text: {
      type: String,
      default: ""
    },
    validation: {
      type: String,
      required: false
    },
    value: {
      required: false
    },
    maxlength: {
      type: Number,
      required: false
    },
    minlength: {
      type: Number,
      required: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    customWrapperStyle: {
      type: Object,
      required: false,
      default: () => {}
    },
    slideUp: Boolean,
    disablePaste: {
      type: Boolean,
      default: () => false
    },
    color: {
      type: String,
      default: "#0F2967"
    },
    borderColor: {
      type: String,
      default: "#a3b8ea"
    },
    fontFamily: {
      type: String
    }
  },
  methods: {
    updateValue(val) {
      this.$emit("component-updated", {
        text: val,
        slideUp: !!val
      });
      this.$emit("input", val);
    },
    pasteHandler(event) {
      if (this.disablePaste) {
        event.preventDefault();
      }
    }
  }
};
</script>

<style scoped lang="scss">
$medium: 800px;

.validation-error {
  position: absolute;
  color: #dc3545;
  font-size: 13px;
  margin-left: 0px;
  margin-top: 0px;
}

.textInputWrapper {
  position: relative;
  margin: 0px;
  font-family: Plus Jakarta Sans !important;

  .error_min {
    width: 16px;
  }
  .inputError {
    position: absolute;
    top: 11px;
    right: 10px;
  }
}
.textInputWrapper .textInput {
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  border: 1px solid var(--borderColor);
  box-sizing: border-box !important;
  padding-left: 15px !important;
  height: 44px !important;
  width: 100%;
  font-size: 16px;
  color: var(--color);
  font-weight: 500;
  &.is-invalid {
    border-color: #dc3545;
    background-color: #fff0f1;
  }
}
.textInputWrapper .floating-label {
  position: absolute;
  top: -17px;
  left: 0;
  padding-right: 7px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 20px;
  color: var(--color);
  font-weight: 700;
}
.textInputWrapper input:focus ~ .floating-label,
.textInputWrapper input:not(:focus):valid ~ .floating-label {
  // transform: translateY(-135%) scale(0.8);
}
.textInputWrapper input:not(:valid) ~ .floating-label {
  color: #808080;
}
// .slideUp {
//   visibility: hidden;
// }

.textInputWrapper input:disabled {
  background-color: #c1c1c1;
}
</style>
